import React, { useEffect, useState, useContext } from "react";
import { ALL_QUESTION_CATEGORIES } from "../../GraphQL/Queries";
import { useMutation, useLazyQuery } from "@apollo/client";
import SmileyFacesBox from "../../components/SmileyFacesBox/SmileyFacesBox";
import {
  CREATE_QUESTION_BANK,
  CREATE_QUESTION_SURVEY,
  UPDATE_QUESTION_BANK,
  UPDATE_QUESTION_SURVEY,
  CREATE_ANSWER_QUESTION_SURVEY,
} from "../../GraphQL/Mutations";
import { getStateLogin } from "../LayoutHome/stateLogin";
import { NotificationManager } from "react-notifications";
import { ContextQuestions } from "../../Store/StoreQuestions";
import ModalLoader from "../../components/ModalLoader/ModalLoader";
import { messages } from "../../util/message";
import { theme as themeConfig } from "../../themes/themes";

const SmileyFacesContainer = (globalProps) => {
  const { identity, dataSurvey } = globalProps;
  const [stateQuestionsReducer, dispatch] = useContext(ContextQuestions);
  const [showLoader, setshowLoader] = useState(false);
  const [textTitle, setTextTitle] = useState("");
  const [selectCategory, setSelectCategory] = useState(0);
  const [selectQuantity, setSelectQuantity] = useState(2);
  const [checkMandatory, setCheckMandatory] = useState(false);
  const [categories, setcategories] = useState([]);

  const [textValidation, setTextValidation] = useState("");

  const [createQuestionBank] = useMutation(CREATE_QUESTION_BANK);
  const [createQuestionSurvey] = useMutation(CREATE_QUESTION_SURVEY);
  const [createAnswerQuestionSurvey] = useMutation(
    CREATE_ANSWER_QUESTION_SURVEY
  );
  const [updateQuestionBank] = useMutation(UPDATE_QUESTION_BANK);
  const [updateQuestionSurvey] = useMutation(UPDATE_QUESTION_SURVEY);
  const [getQuestionCategories, { loading, error }] = useLazyQuery(
    ALL_QUESTION_CATEGORIES,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        if (!data.allCategoriesQuestion.withError) {
          const allCategories = data.allCategoriesQuestion.outputData.map(
            (c) => ({ ...c })
          );
          if (dataSurvey?.isGlobal) {
            setcategories(
              allCategories.filter((f) => f.description === "Global")
            );
          } else {
            setcategories(
              allCategories.filter((f) => f.description !== "Global")
            );
          }
        }
      },
    }
  );
  const [questionSettings, setQuestionSettings] = useState([
    { id: 1, lbtext: "", value: "1", face: "", color: themeConfig.neutral.black },
    { id: 2, lbtext: "", value: "1", face: "", color: themeConfig.neutral.black },
  ]);
  const [showTooltipDescription, setShowTooltipDescription] = useState(false);
  const [tooltipInformationCheck, setTooltipInformationCheck] = useState(false);
  const [tooltipDescriptionText, setTooltipDescriptionText] = useState("");
  const [configQuestionStyle, setconfigQuestionStyle] = useState({
    question: {
      fontFamily: "",
      fontWeight: "",
      fontStyle: "",
      textDecoration: "",
      fontSize: "",
      color: "",
    },
    answer: {
      fontFamily: "",
      fontWeight: "",
      fontStyle: "",
      textDecoration: "",
      fontSize: "",
      color: "",
    },
    customStyle: false,
    background: "",
    alignment: "",
    typeQuestion: "SmileyFaces",
    caritas: questionSettings,
    tooltip: {
      status: tooltipInformationCheck,
      descriptionText: tooltipDescriptionText,
    },
  });

  const changeTooltipInformationCheck = (status) => {
    configQuestionStyle.tooltip.status = status;
    let newConfigQuestionStyle = configQuestionStyle;
    setconfigQuestionStyle(newConfigQuestionStyle);
    setTooltipInformationCheck(status);
  };

  useEffect(() => {
    if (globalProps.GidQuestionSurvey) {
      let jsonConfSurveyQuestion = JSON.parse(globalProps.GjsonConfiguration);

      setTextTitle(globalProps.GnameQuestion);
      setSelectCategory(globalProps.GidCategoryQuestion);

      setCheckMandatory(globalProps.GisMandatory);
      setTextValidation(globalProps.GvalidationText);

      setSelectQuantity(jsonConfSurveyQuestion.caritas.length);
      setQuestionSettings(jsonConfSurveyQuestion.caritas);
      setconfigQuestionStyle(jsonConfSurveyQuestion);
    }
    getQuestionCategories();
  }, []);

  useEffect(() => {
    if (globalProps.GjsonConfiguration !== "") {
      const parsedJSON = JSON.parse(globalProps.GjsonConfiguration);
      if (parsedJSON.tooltip) {
        setTooltipInformationCheck(parsedJSON.tooltip.status);
        setTooltipDescriptionText(parsedJSON.tooltip.descriptionText);
      }
    }
  }, []);

  let saveQuestionSurvey = (
    idQuestion,
    isMandatory,
    questionSettings,
    copyText
  ) => {
    configQuestionStyle.caritas = questionSettings;

    createQuestionSurvey({
      variables: {
        idQuestion: idQuestion,
        idSurvey: globalProps.GidSurvey,
        jsonConfiguration: JSON.stringify(configQuestionStyle),
        isMandatory: isMandatory,
        order: globalProps.Gorder,
        active: true,
        createUser: getStateLogin(),
      },
    }).then((response) => {
      if (copyText != "") {
        dispatch({
          type: "CLONE_QUESTION",
          payload: {
            Gtype: "SmileyFaces",
            GindexQuestion: globalProps.GindexQuestion + 1,
            Gactive: true,
            GidSurvey: globalProps.GidSurvey,
            GidQuestion: idQuestion,
            GidCategoryQuestion: selectCategory,
            GnameQuestion: textTitle + copyText,
            GvalidationText: textValidation,
            GidQuestionSurvey: response.data.createQuestionSurvey,
            GisMandatory: checkMandatory,
            GjsonConfiguration: JSON.stringify(configQuestionStyle),
            Gorder: globalProps.Gorder + 1,
            GisEdit: false,
            GisDependent: false,
            GidParentQuestion: null,
            GdependentAnswer: null,
            clonePosition: globalProps.GindexQuestion + 1,
          },
        });
      } else {
        dispatch({
          type: "SAVE_QUESTIONS",
          payload: {
            GindexQuestion: globalProps.GindexQuestion,
            GisEdit: false,
            GnameQuestion: textTitle,
            GidCategoryQuestion: selectCategory,
            GisMandatory: checkMandatory,
            Gorder: globalProps.Gorder,
            GvalidationText: textValidation,
            GidQuestion: idQuestion,
            GidQuestionSurvey: response.data.createQuestionSurvey,
            GjsonConfiguration: JSON.stringify(configQuestionStyle),
          },
        });
      }
      setshowLoader(false);
      createAnswerQuestionSurvey({
        variables: {
          idQuestionSurvey: response.data.createQuestionSurvey,
          idCategoryAnswer: 4,
          createUser: getStateLogin(),
        },
      })
        .then((data) => {
          if (data.createAnswerQuestionSurvey) {
            NotificationManager.success(
              "New questions were saved successfully",
              "",
              5000
            );
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    });
  };

  let updateInQuestionSurvey = (idInBank, isMandatory, questionSettings) => {
    configQuestionStyle.caritas = questionSettings;
    updateQuestionSurvey({
      variables: {
        idQuestionSurvey: globalProps.GidQuestionSurvey,
        idQuestion: idInBank,
        idSurvey: globalProps.GidSurvey,
        jsonConfiguration: JSON.stringify(configQuestionStyle),
        isMandatory: isMandatory,
        order: globalProps.Gorder,
        active: true,
        lastUpdateUser: getStateLogin(),
      },
    }).then((response) => {
      dispatch({
        type: "UPDATE_QUESTIONS",
        payload: {
          GindexQuestion: globalProps.GindexQuestion,
          GisEdit: false,
          GnameQuestion: textTitle,
          GidCategoryQuestion: selectCategory,
          GisMandatory: checkMandatory,
          Gorder: globalProps.Gorder,
          GvalidationText: textValidation,
          GjsonConfiguration: JSON.stringify(configQuestionStyle),
        },
      });
      setshowLoader(false);
    });
  };

  let saveQuestionBank = (clone) => {
    let title = textTitle;
    let category = selectCategory;
    let isMandatory = checkMandatory;
    if (
      title.trim() !== "" &&
      parseInt(category) !== 0 &&
      ((isMandatory && textValidation.trim() !== "") ||
        (tooltipInformationCheck && tooltipDescriptionText !== "") ||
        !isMandatory ||
        !tooltipInformationCheck)
    ) {
      if (
        !tooltipInformationCheck ||
        (tooltipInformationCheck && tooltipDescriptionText !== "")
      ) {
        setshowLoader(true);
        let copyText = clone ? " - Copy" : "";
        let validationText = textValidation;
        if (isMandatory && textValidation !== "") {
          if (globalProps.GidQuestionSurvey && !clone) {
            updateQuestionBank({
              variables: {
                idQuestion: globalProps.GidQuestion,
                nameQuestion: title,
                validationText: validationText,
                idCategoryQuestion: parseInt(category),
                active: true,
                lastUpdateUser: getStateLogin(),
              },
            }).then(() => {
              updateInQuestionSurvey(
                globalProps.GidQuestion,
                isMandatory,
                questionSettings
              );
            });
          } else {
            createQuestionBank({
              variables: {
                nameQuestion: title + copyText,
                validationText: validationText,
                idCategoryQuestion: parseInt(category),
                active: true,
                createUser: getStateLogin(),
              },
            }).then((saveResponse) => {
              saveQuestionSurvey(
                saveResponse.data.createQuestionBank,
                isMandatory,
                questionSettings,
                copyText
              );
            });
          }
        } else {
          if (!isMandatory) {
            if (globalProps.GidQuestionSurvey && !clone) {
              updateQuestionBank({
                variables: {
                  idQuestion: globalProps.GidQuestion,
                  nameQuestion: title,
                  validationText: "",
                  idCategoryQuestion: parseInt(category),
                  active: true,
                  lastUpdateUser: getStateLogin(),
                },
              }).then(() => {
                updateInQuestionSurvey(
                  globalProps.GidQuestion,
                  isMandatory,
                  questionSettings
                );
              });
            } else {
              createQuestionBank({
                variables: {
                  nameQuestion: title + copyText,
                  validationText: "",
                  idCategoryQuestion: parseInt(category),
                  active: true,
                  createUser: getStateLogin(),
                },
              }).then((saveResponse) => {
                saveQuestionSurvey(
                  saveResponse.data.createQuestionBank,
                  isMandatory,
                  questionSettings,
                  copyText
                );
              });
            }
          } else if (isMandatory && validationText === "") {
            if (globalProps.GidQuestionSurvey && !clone) {
              updateQuestionBank({
                variables: {
                  idQuestion: globalProps.GidQuestion,
                  nameQuestion: title,
                  validationText: validationText,
                  idCategoryQuestion: parseInt(category),
                  active: true,
                  lastUpdateUser: getStateLogin(),
                },
              }).then(() => {
                updateInQuestionSurvey(
                  globalProps.GidQuestion,
                  isMandatory,
                  questionSettings
                );
              });
            } else {
              createQuestionBank({
                variables: {
                  nameQuestion: title + copyText,
                  validationText: validationText,
                  idCategoryQuestion: parseInt(category),
                  active: true,
                  createUser: getStateLogin(),
                },
              }).then((saveResponse) => {
                saveQuestionSurvey(
                  saveResponse.data.createQuestionBank,
                  isMandatory,
                  questionSettings,
                  copyText
                );
              });
            }
          }
        }
      } else {
        handleNoTooltipDesMessage();
      }
    } else {
      handleNoQuestionTitle();
      handleNoCategory();
      handleNoMandatoryText();
      handleNoTooltipDesMessage();
    }
  };

  let handleNoQuestionTitle = () => {
    if (textTitle.trim() === "") {
      NotificationManager.warning(messages.QuestionTitle);
    }
  };

  let handleNoCategory = () => {
    if (parseInt(selectCategory) === 0) {
      NotificationManager.warning(messages.QuestionCategory);
    }
  };

  let handleNoMandatoryText = () => {
    if (checkMandatory && textValidation.trim() === "") {
      NotificationManager.warning(messages.QuestionMandatory);
    }
  };

  let handleNoTooltipDesMessage = () => {
    if (tooltipInformationCheck && tooltipDescriptionText === "") {
      NotificationManager.warning(messages.QuestionTooltipDescription);
    }
  };

  let handleEdit = () => {
    if (
      stateQuestionsReducer.questions.filter((f) => f.GisEdit === true).length
    ) {
      NotificationManager.warning(
        "All questions must be saved before to edit another question",
        "",
        5000
      );
      return;
    }
    dispatch({
      type: "EDIT_QUESTIONS",
      payload: {
        GindexQuestion: globalProps.GindexQuestion,
        GisEdit: true,
      },
    });
  };

  let handleCancel = () => {
    let objG = stateQuestionsReducer.questions[globalProps.GindexQuestion];

    let jsonConfSurveyQuestion = JSON.parse(objG.GjsonConfiguration);

    setTextTitle(globalProps.GnameQuestion);
    setSelectCategory(globalProps.GidCategoryQuestion);

    setCheckMandatory(globalProps.GisMandatory);
    setTextValidation(globalProps.GvalidationText);

    setSelectQuantity(jsonConfSurveyQuestion.caritas.length);
    setQuestionSettings(jsonConfSurveyQuestion.caritas);
    setconfigQuestionStyle(jsonConfSurveyQuestion);

    if (jsonConfSurveyQuestion.tooltip) {
      setTooltipInformationCheck(jsonConfSurveyQuestion.tooltip.status);
      setTooltipDescriptionText(jsonConfSurveyQuestion.tooltip.descriptionText);
    }

    dispatch({
      type: "CANCEL_QUESTIONS",
      payload: {
        GindexQuestion: globalProps.GindexQuestion,
        GisEdit: false,
      },
    });
  };

  let handleDelete = () => {
    setshowLoader(true);
    if (globalProps.GidQuestionSurvey !== 0) {
      updateQuestionBank({
        variables: {
          idQuestion: globalProps.GidQuestion,
          active: false,
          lastUpdateUser: getStateLogin(),
        },
      }).then((result) => {
        updateQuestionSurvey({
          variables: {
            idQuestionSurvey: globalProps.GidQuestionSurvey,
            idQuestion: globalProps.GidQuestion,
            idSurvey: globalProps.GidSurvey,
            jsonConfiguration: "",
            isMandatory: false,
            order: 0,
            active: false,
            lastUpdateUser: getStateLogin(),
          },
        }).then((resultUpdate) => {
          let copy = JSON.parse(JSON.stringify(stateQuestionsReducer));
          copy.questions.splice(globalProps.GindexQuestion, 1);
          copy.questions.map((q, index) => {
            q.GindexQuestion = index;
            q.Gorder = index + 1;
          });
          dispatch({ type: "CLEAN_QUESTIONS" });
          dispatch({ type: "DELETE_QUESTIONS", payload: copy });
        });
      });
    } else {
      setshowLoader(false);
      let copy = JSON.parse(JSON.stringify(stateQuestionsReducer));
      copy.questions.splice(globalProps.GindexQuestion, 1);
      copy.questions.map((q, index) => {
        q.GindexQuestion = index;
        q.Gorder = index + 1;
      });
      dispatch({ type: "CLEAN_QUESTIONS" });
      dispatch({ type: "DELETE_QUESTIONS", payload: copy });
    }
  };

  let handleTextAreaText = (value) => {
    setTooltipDescriptionText(value);
    configQuestionStyle.tooltip.descriptionText = value;
    let newConfigQuestionStyle = configQuestionStyle;
    setconfigQuestionStyle(newConfigQuestionStyle);
  };

  return (
    <>
      <SmileyFacesBox
        error={error}
        loading={loading}
        data={categories}
        textTitle={textTitle}
        setTextTitle={setTextTitle}
        selectCategory={selectCategory}
        setSelectCategory={setSelectCategory}
        checkMandatory={checkMandatory}
        setCheckMandatory={setCheckMandatory}
        textValidation={textValidation}
        setTextValidation={setTextValidation}
        selectQuantity={selectQuantity}
        setSelectQuantity={setSelectQuantity}
        editable={globalProps.GisEdit}
        questionSettings={questionSettings}
        setQuestionSettings={setQuestionSettings}
        saveQuestionBank={saveQuestionBank}
        handleEdit={handleEdit}
        handleCancel={handleCancel}
        configQuestionStyle={configQuestionStyle}
        setconfigQuestionStyle={setconfigQuestionStyle}
        handleDeleteQuestion={handleDelete}
        idQuestionSurvey={globalProps.GidQuestionSurvey}
        globalProps={globalProps}
        categories={categories}
        identity={identity}
        tooltipInformationCheck={tooltipInformationCheck}
        tooltipDescriptionText={tooltipDescriptionText}
        setShowTooltipDescription={setShowTooltipDescription}
        handleTextAreaText={handleTextAreaText}
        changeTooltipInformationCheck={changeTooltipInformationCheck}
        showTooltipDescription={showTooltipDescription}
      />
      {showLoader && <ModalLoader></ModalLoader>}
    </>
  );
};

export default SmileyFacesContainer;
